import React, { useState, useEffect } from "react";

import { Modal, Button, Header, Input, Divider, Loader, Dimmer } from "semantic-ui-react";
import "./OperatorConfirmModal.css";
import NumPad from "../NumPad/NumPad";
import * as Constants from "../../utils/Constants";
import SharedFunctions from "../../utils/SharedFunctions";
import OperatorEndpoints from "../../lib/operator/OperatorEndpoints";
import { OPERATOR_CONFIRM_MODAL } from "../../utils/constants/componentConstants";

const { KeyPadKeyCode } = Constants;

const OperatorConfirmModal = ({
  open,
  onClose,
  SortBoxID,
  orderNumber,
  isScanIdValidationRxRequired,
  reviewMode = false
}) => {
  const [operatorID, setOperatorID] = useState("");
  const [shownValue, setShownValue] = useState("");
  const [password, setPassword] = useState(-1);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    function onOpen() {
      SharedFunctions.LogPopupShownEvent(OPERATOR_CONFIRM_MODAL);
    }
    if (open) {
      onOpen();
    }
  }, [open]);

  const numberChange = (value, target) => {
    if (value) {
      let parsedValue = parseInt(value);
      if (parsedValue && parsedValue > 0) {
        value = parsedValue;
      } else {
        value = "";
      }
    }
    target(value + "");
  };

  useEffect(() => {
    if (inputRef && inputRef.current && inputRef.current.focus) {
      inputRef.current.focus();
    }
  });

  const setInputFocus = () => {
    if (inputRef && inputRef.current && inputRef.current.focus) {
      inputRef.current.focus();
    }
  }

  const inputRef = React.createRef();

  const setShownValueAndPlaceholderValue = (val) => {
    setShownValue([...val].map((x) => "•").join(""));
    setOperatorID(val);
  };

  const clearState = () => {
    setOperatorID("");
    setPassword(-1);
    setError("");
  };

  const onCloseClearState = () => {
    clearState();
    setShownValueAndPlaceholderValue("");
    if (typeof onClose === "function") {
      onClose();
    }
  };

  function operatorNotVaild() {
    setShownValueAndPlaceholderValue("");
    setError("Ansvarig operatör behöver bekräfta");
  }

  const onKeyPadInput = (key) => {
    setError("");
    if (key === KeyPadKeyCode.BACKSPACE) {
      numberChange(operatorID.substr(0, operatorID.length - 1), setShownValueAndPlaceholderValue);
    } else if ((key || key === KeyPadKeyCode.ZERO) && key !== KeyPadKeyCode.BACKSPACE) {
      numberChange(operatorID + key, setShownValueAndPlaceholderValue);
    }
  };

  function checkInput() {
    setLoading(true);
    OperatorEndpoints.canVerifyRXBag(
      operatorID,
      SortBoxID,
      orderNumber,
      isScanIdValidationRxRequired
    ).then((canVerify) => {
      if (canVerify) {
        return onCloseClearState();
      } else {
        operatorNotVaild();
      }
      setLoading(false);
    })
    .finally(() => {
      setLoading(false)
    });
  }

  function keyboardInputActions(e) {
    if (operatorID === "") {
      setShownValueAndPlaceholderValue("");
    }

    let key = e.keyCode;
    if (key === 8) {
      numberChange(operatorID.substr(0, operatorID.length - 1), setShownValueAndPlaceholderValue);
    }
    if (key === 13) {
      checkInput();
    }
  }

  function keyboardInput(e) {
    setError("");
    var targetValue = e.target.value;
    var value = targetValue.replace(/[^0-9.]/g, "");
    let currentWithNew = operatorID + value;
    let newOperatorId = currentWithNew;
    setShownValueAndPlaceholderValue(newOperatorId);
  }

  const getInfoText = () => {

    if (reviewMode) {
      return "En ansvarig behöver scanna sin bricka och bekräfta för att fortsätta."
    }

    return isScanIdValidationRxRequired
      ? "En ansvarig behöver scanna sin bricka och bekräfta för att fortsätta. Sedan kommer facket behöva packas om från början."
      : "En ansvarig behöver logga in och bekräfta för att fortsätta. Sedan kommer facket behöva packas om från början.";
  };

  const getOperatorConfirmInputPlaceholder = () => {
    return isScanIdValidationRxRequired ? "Scanna bricka" : "Operatörsnummer";
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="small"
      className={"OperatorConfirmModal"}
      closeOnDimmerClick={false}
      closeOnEscape={false}
      onOpen={() => setInputFocus()}
      onClick={() => setInputFocus()}
      onBlur={() => setInputFocus()}>
      <Header
        icon="warning sign"
        color="red"
        content="RX-påse scannad som inte tillhör denna order"
      />
      <Modal.Content>
        <Dimmer active={loading} inverted>
          <Loader size="big" />
        </Dimmer>
        <div className="operator-name-info">{getInfoText()}</div>
        <div className="error-message" style={{ display: error ? "inline-block" : "none" }}>
          {error}
        </div>
        <Input
          id="OperatorConfirmInput"
          fluid
          size="massive"
          placeholder={getOperatorConfirmInputPlaceholder()}
          autoFocus
          autoComplete="off"
          onChange={(e) => keyboardInput(e)}
          onKeyDown={(e) => keyboardInputActions(e)}
          value={shownValue ? shownValue : ""}
          ref={inputRef}
        />
        <Divider style={{ display: "none" }} />
        <Input
          placeholder="Lösenord"
          type="password"
          value={password >= 0 ? password : ""}
          style={{ display: "none" }}
          autoComplete="new-password"
          autoFocus
          disabled
        />
        <NumPad onClick={(val) => onKeyPadInput(val)} />
      </Modal.Content>
      <Modal.Actions>
        <Button color="green" onClick={(e) => checkInput()}>
          Bekräfta
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default OperatorConfirmModal;
